import { FC } from 'react'

type Props = {
  text: string
}

const PassFormHeader: FC<Props> = ({ text }) => {
  return (
    <div className="mb-16 text-left font-pro text-grey-70 text-24 xs:text-14">
      {text}
    </div>
  )
}

export { PassFormHeader }
